/**
 * Renova o JWT via GET /api/usuario (sessão Sanctum), single-flight.
 */
import axios from 'axios';
import { getApiBaseUrl } from '@/api';
import { persistJwtFromApiResponse } from './localSession';

let inFlight = null;

export function refreshJwtViaUsuario() {
  if (inFlight) {
    return inFlight;
  }

  const url = getApiBaseUrl().replace(/\/$/, '') + '/api/usuario';

  inFlight = axios
    .get(url, {
      withCredentials: true,
      headers: {
        Accept: 'application/json, text/plain, */*',
        'X-Requested-With': 'XMLHttpRequest',
      },
    })
    .then((response) => {
      if (response && response.data) {
        persistJwtFromApiResponse(response.data);
      }
      return true;
    })
    .catch(() => false)
    .finally(() => {
      inFlight = null;
    });

  return inFlight;
}

/** Só para testes. */
export function resetRefreshJwtViaUsuarioState() {
  inFlight = null;
}
